<template lang="">
    <Card class="">
        <template #title> Yeni Yazı</template>
<template #content>
            <div class="formgrid grid">
                <div class="field col-6">
            <label for="Baslik"><b>Başlık</b></label>
            <IconField iconPosition="left">
                <InputIcon class="pi pi-user"> </InputIcon>
                <InputText v-model="Baslik" style="width:100%" />
            </IconField>
           
        </div>
        <div class="field col-6">
            <label for="YazarAd"><b>Yazar Adı</b></label>
            <IconField iconPosition="left">
                <InputIcon class="pi pi-user"> </InputIcon>
                <InputText v-model="YazarAd"  style="width:100%"/>
            </IconField>
        </div>
                <div class="field col-2">
                    <input class="p-button p-component p-button-sm p-mr-2 p-mb-2 " type="file" accept="image/*" @change="customBase64Uploader">
                </div>
                <div class="field col-5"></div>
                <div class="field col-5">
                    <Image :v-if="imageIsEmpty" :src="image" alt="Image" preview width="300" />
                </div>
                <div class="field col-12">
                    <label for="Onyazi"><b>Ön Yazı</b></label>
                <Textarea v-model="Onyazi" autoResize rows="3" cols="30"   style="width:100%"/>

                </div>
                <div class="field col-12">
                    <hr class="solid">
                </div>
                <div class="field col-12 ">
                    <Editor v-model="blogText"  style="height:49vh; width:100%" />
                </div>

            </div>
        </template>
<template #footer>
            <div class="flex flex-row-reverse flex-wrap mt-5">
                <Button icon="pi pi-check" label="Kaydet" class="border-round m-2" severity="success" :onclick="Kaydet" />
                <Button icon="pi pi-times" label="İptal" class="border-round m-2" severity="danger" />
            </div>
        </template>
</Card>

</template>

<script>
import GlobalServis from "../../../../services/GlobalServis";
export default {
    data() {
        return {
            image: require('../../../../assets/genel/not_found_image.jpg'),
            imageIsEmpty: true,
            Baslik: '',
            YazarAd: '',
            blogText: '',
            Onyazi: ''
        }
    },
    methods: {
        customBase64Uploader(event) {
            this.imageIsEmpty = true;
            const file = event.target.files[0];
            const reader = new FileReader();
            // eslint-disable-next-line
            let blob = fetch(file).then((r) => r.blob()); //blob:url
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                this.image = reader.result;
                this.imageIsEmpty = false;
            };
        },

        Kaydet() {
            let data = {
                image: Buffer.from(this.image, 'utf8').toString('base64'),
                baslik: this.Baslik,
                yazarad: this.YazarAd,
                blogtext: this.blogText,
                Onyazi: this.Onyazi
            }
            GlobalServis.GlobalServis("POST", "SetBlogYazi", data).then((res) => {
                if (res.status == 200) {
                    this.$toast.add({
                        severity: "success",
                        summary: "Başarılı",
                        detail: "Kaydedildi",
                        life: 3000,
                    });
                    this.$router.push({ path: "/Blog_/TumYazilar" });
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            }).then(() => {
            });
        }
    },
    mounted() {
        // window.$("[data-pc-section=uploadbutton]").hide();

    }
}
</script>

<style lang="scss" scoped></style>
